import api from '@/api'

export default {

    /**
     * 예산관리 용 부서 목록 조회
     * @param year 연도
     * @param halfYear 전반기, 하반기 구분 (H1: 3~8, H2: 9~2)
     */
    getDeptInfoList(year: string, halfYear: string): Promise<Array<budget.BudgetDeptInfo>>{
        return api.get<Array<budget.BudgetDeptInfo>>({
            url: '/yek/budget/api/budgetDeptList',
            params: {
                year: year,
                halfYear: halfYear
            }
        })
    },

    /**
     * 예산 실적 조회
     * @param searchDate yyyy-MM 형식 일자
     * @param deptCode 부서코드
     */
    getBudgetExpenseData(searchDate: string, deptCode: string, isTotal : boolean): Promise<Array<budget.BudgetExpenseItem>>{
        return api.get<Array<budget.BudgetExpenseItem>>({
            url: '/yek/budget/api/portalBudgetList',
            params: {
                searchDate: searchDate,
                deptCode: deptCode,
                isTotal: isTotal
            }
        })
    },

    /**
     * 예산관리 용 부서 목록 조회
     * @param searchDate
     */
    getBudgetDeptList(searchDate: string): Promise<Array<budget.BudgetDeptInfo>>{
        return api.get<Array<budget.BudgetDeptInfo>>({
            url: '/yek/budget/api/portalBudgetDeptList',
            params: {
                searchDate: searchDate
            }
        });
    }
}
